<!-- <div class="d-flex justify-content-center">
  <h1 mat-dialog-title class="soft-landing-title">Welkom bij Park the Sun</h1>
</div> -->
<mat-dialog-content class="mat-typography">
  <div class="welcome-message mx-auto mb-4 d-flex justify-content-around align-items-center">
    <img *ngIf="url == 0" class="welcome-logo" [src]="landingLogo">
    <img *ngIf="url > 0" class="img-30" [src]="landingLogo">
  </div>
  <div class="mx-5">
    <p class="welcome-message mx-auto" [innerHTML]="landingText"></p>
  </div>

  <div class="d-flex flex-column mt-5 yellow-landing-banner justify-content-center align-items-center mb-5">
    <div class="d-flex justify-content-center">
      <button class="p-2 button-primary welkom-button" mat-dialog-close>Naar applicatie</button>
      <button class="p-2 button-primary welkom-button" (click)="openPracticePage()" mat-dialog-close>Voorbeeld</button>
    </div>
  </div>
  <div class="row">
    <div class="p-2 d-flex flex-column col-12 col-xl-4">
      <img class="icon-md mx-auto" src="../../../assets/images/legal.png">
      <p class="p-3">Op basis van data en modellen biedt Park the Sun inzicht in de mogelijkheden van solar carports. Wil je echt aan de slag met de bouw? Dan adviseren wij aanvullend onderzoek te doen. Aan de uitkomsten van deze applicatie kunnen geen rechten worden ontleend.</p>
    </div>
    <div class="p-2 d-flex flex-column col-12 col-xl-4">
      <img class="icon-md mx-auto" src="../../../assets/images/location.png">
      <p class="p-3">Door het slimme Park the Sun algoritme te combineren met openbare data worden meer parkeerplekken gevonden dan ooit. Hier zijn we best trots op. Let op: het overzicht is niet 100% volledig. Er kunnen parkeerlocaties ontbreken.
      </p>
    </div>
    <div class="p-2 d-flex flex-column col-12 col-xl-4">
      <img class="icon-md mx-auto" src="../../../assets/images/pts_calculator.png">
      <p class="p-3">De getallen en bedragen in Park the Sun zijn gebaseerd op data analyse en expert input. Inschattingen zijn zorgvuldig tot stand gekomen. Jaarlijks worden gegevens bijgewerkt in samenspraak met gemeenten.</p>
    </div>
  </div>
  <div class="d-flex flex-row justify justify-content-center">
    <button class="button-primary" mat-dialog-close>Naar applicatie</button>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="button-primary btn-narrow" mat-dialog-close>Sluiten</button>
</mat-dialog-actions>


<!-- Copyright 2020 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->